<template>
    <div class="content">
        <div class="header">
            <img src="../assets/logo.png">
            <span class="title">国家信息化计算机教育认证证书查询系统</span>
        </div>
        <div class="main" style="padding-top:20px;">
            <Form ref="formValidate" :model="queryView" :rules="ruleValidate" :label-width="100">
                <FormItem label="姓名" prop="Name" style="width: 60%;margin: 0 auto 20px;">
                    <Input v-model="queryView.Name" placeholder="请输入姓名"></Input>
                </FormItem>
                <FormItem label="证件号码" prop="IdNum" style="width: 60%;margin: 0 auto 20px;">
                    <Input v-model="queryView.IdNum" placeholder="请输入证件号码"></Input>
                </FormItem>
                <FormItem style="width: 60%;margin: 0 auto 20px;">
                    <Button type="primary" @click="handleSearch">查询</Button>
                </FormItem>
            </Form>
        </div>
        <div class="footer">
            <div>
                <span class="dhr"></span>
                Copyright© 2002-2010 www.exam.org.cn All Rights Reserved. Powered by Co-Education
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Main',
        data () {
            return {
                queryView:{
                    Name:"",
                    IdNum:""
                },
                ruleValidate: {
                    Name: [
                        { required: true, message: '姓名不可为空', trigger: 'blur' }
                    ],
                    IdNum: [
                        { required: true, message: '证件号码不可为空', trigger: 'blur' },
                    ]
                }
            }
        },
        created() {
            //禁止浏览器回退
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', function () {
                history.pushState(null, null, document.URL);
            })
        },
        methods: {
            handleSearch() {
                this.queryView.Name = this.queryView.Name.replace(/\s+/g, "");
                this.queryView.IdNum = this.queryView.IdNum.replace(/\s+/g, "");
                this.$refs['formValidate'].validate((valid) => {
                    if (valid) {
                        this.$router.push({
                            name: 'ResultPage',
                            query: this.queryView,
                        })
                    }
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content {
        width: 778px;
        margin: 0 auto;
    }

    .header {
        text-align: left;
        padding-top: 20px;
    }

    .header img {
        border-width: 0;
    }

    .title {
        font-size: 30px;
        font-weight: bold;
        color: rgb(15,65,117);
    }

    .dhr {
        display: inline-block;
        height: 1px;
        background-color: #999999;
        overflow: hidden;
        width: 99%;
        margin: 9px auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue